export default __webpack_public_path__ + "static/media/gallery-wip-emitter_09.2655e8b8.jpg";